import {Injectable} from '@angular/core';
import {TkFile} from '../../interfaces/core/tk-file';
import {Platform} from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class FilesystemService {

  private readonly _path: string = 'tk/';

  constructor(private platform: Platform) {}

  /**
   *
   * @param blob
   */
  public convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onerror = reject;
    reader.onload = () => {
      resolve(reader.result);
    };
    reader.readAsDataURL(blob);
  });

  /**
   *
   * @param path
   * @param withoutPostfix
   * @private
   */
  public generatePath(path: string, withoutPostfix: boolean = false): string {
    const postfix: string = withoutPostfix ? '' : '/';
    if (path) {
      return this.trimPath(this._path + path) + postfix;
    }
    return this._path;
  }

  /**
   *
   * @param path
   * @private
   */
  public trimPath(path: string): string {
    return path.replace(/^\/|\/$/g, '');
  }

  /**
   *
   * @param base64
   * @param contentType
   * @private
   */
  public base64ToBlob(base64: string, contentType: string = 'application/pdf'): Blob {
    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    return new Blob([byteArray], { type: contentType });
  }

  /**
   *
   * @param tkFile
   * @private
   */
  public async readAsBase64(tkFile: TkFile) {
    // Fetch the photo, read as a blob, then convert to base64 format
    const response = await fetch(tkFile.webviewPath!);
    const blob = await response.blob();

    return await this.convertBlobToBase64(blob) as string;
  }

}
